// Textes de l'« expérience » de la page d'accueil : le bandeau d'ouverture
// (Hero/HeroSection.jsx), le déroulé en 4 photos (HowItWorks.jsx) et la démo
// jouable (GameDemo.jsx).
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
export default {
  /* ----------------------------------------------------- HeroSection */

  'hero.badge': '🤫 Vous savez déjà. Eux, pas encore.',

  // Le titre est coupé en deux lignes, la seconde est en dégradé.
  'hero.titre.ligne1': 'Faites-leur découvrir',
  'hero.titre.ligne2': 'LE GRAND SECRET',

  // Phrase découpée autour du <strong> et des <br /> : le gras lève le
  // contresens (« ce n'est pas VOUS qui découvrez le sexe »).
  'hero.accroche.fort': 'Vous connaissez le sexe de bébé. Vos proches, non.',
  'hero.accroche.texte':
    'Ce jeu le leur fait deviner : deux équipes, 11 questions « maman ou papa ? », et une dernière pièce de puzzle à gratter qui l’annonce à tout le monde en même temps.',
  'hero.accroche.objet': '📦 Une vraie boîte de jeu en carton, livrée chez vous.',

  'hero.cta.offre': '✨ Découvrez notre offre',
  'hero.cta.enSavoirPlus': '↓ En Savoir Plus',

  'hero.atout.pieces': '12 pièces, pas 1000',
  'hero.atout.joueurs': 'De 2 à 10 joueurs',
  'hero.atout.duree': '20 minutes',

  'hero.imageAlt':
    'Joyful Reveal — jeu de gender reveal Mirum Games : le puzzle des deux oursons, « baby boy » ou « baby girl »',
  'hero.scroll': 'Scroll pour découvrir',

  /* ------------------------------------------------------ HowItWorks */

  'how.badge': 'Le scénario',
  'how.titre': 'Invitez-les à dîner. Ne dites rien.',
  'how.description':
    'Pour eux, c’est un repas comme un autre. Au dessert, vous proposez un petit jeu de société… et c’est là que tout commence. Vingt minutes plus tard, ils savent.',

  'how.etape1.titre': '« On fait un petit jeu ? »',
  'how.etape1.texte':
    'La boîte arrive sur la table. Chacun choisit son camp — team fille ou team garçon — et vous posez la première des onze questions « maman ou papa ? ».',
  'how.etape1.alt':
    'Le contenu du jeu Joyful Reveal : la boîte, la fiche de questions et les deux pochons',

  'how.etape2.titre': 'Pour répondre, il faut du bruit',
  'how.etape2.texte':
    'Pas de main levée : on attrape des jouets d’enfants — hochets, jouets qui couinent — et on fait un maximum de bruit. C’est vous qui décidez quelle équipe répond.',
  'how.etape2.alt': 'Les deux pochons en tissu remis aux deux équipes du jeu',

  'how.etape3.titre': 'L’ambiance monte en crescendo',
  'how.etape3.texte':
    'L’équipe que vous n’avez pas choisie fait deux fois plus de bruit à la question suivante. Puis l’autre. Chaque bonne réponse gagne une pièce ; à la onzième, tout le monde assemble le puzzle.',
  'how.etape3.alt':
    'Le puzzle Joyful Reveal assemblé dans son cadre doré, la pièce à gratter encore grise',

  'how.etape4.titre': 'La douzième pièce se gratte',
  'how.etape4.texte':
    'Une dernière question, un seul gagnant. Le silence, puis le cri : le moment que vos proches vous raconteront pendant des années.',
  'how.etape4.alt':
    'Une main gratte à la pièce de monnaie la dernière pièce du puzzle : le mot GIRL apparaît',

  // Phrase de fin coupée autour du lien : « <lien> — suite ».
  'how.lienRegles': 'Lire les règles complètes',
  'how.lienReglesSuite': '— questions incluses, prêtes à imprimer.',

  // « Le secret des parents » — carte affichée sous le scénario (accueil,
  // fiche produit) et repliée sur la page des règles, que le QR code de la
  // boîte ouvre aussi pour les invités.
  'secret.label': '🤫 Réservé aux parents',
  'secret.titre': 'Le secret des parents',
  'secret.texte':
    'Vous êtes les seuls à connaître les questions à l’avance, et c’est vous qui choisissez l’équipe qui répond. Alors vous pouvez, très discrètement, aider la chance.',
  'secret.parrain':
    'Vous aimeriez demander à quelqu’un d’être parrain ou marraine ? Donnez la parole à son équipe quand vous savez qu’il ou elle a la réponse. En finale, posez une question dont la réponse est un nombre que vous lui aurez confié quelques jours avant. C’est sa main qui grattera la dernière pièce.',
  'secret.chute': 'Et la question suivante, c’est vous qui la poserez.',
  'secret.afficher': '👀 Afficher le secret (parents uniquement)',

  /* -------------------------------------------------------- GameDemo */

  'demo.badge': 'Essayez maintenant — une partie express',
  'demo.titre': 'Jouez, comme au jour J',
  'demo.intro':
    "Deux équipes, onze questions, un puzzle qui s'assemble. La douzième pièce se gratte — et c'est elle qui dit tout. Voici la partie, en une minute.",

  // Annonces pour les lecteurs d'écran (aria-live) : chaque étape de la démo.
  'demo.etape.pari': 'Étape 1 sur 4 — formez votre équipe',
  'demo.etape.questions': 'Étape 2 sur 4 — gagnez les pièces',
  'demo.etape.cascade': 'Étape 2 sur 4 — le puzzle se remplit',
  'demo.etape.subsidiaire': 'Étape 3 sur 4 — la question subsidiaire',
  'demo.etape.grattage': 'Étape 4 sur 4 — la grande révélation',
  'demo.etape.final': 'Partie terminée',
  'demo.aria.resultat': "Résultat de la démonstration : c'est {mot}.",

  // Le sexe tiré au sort, tel qu'il s'insère dans les phrases : « C'est {mot} ! »
  'demo.resultat.fille': 'une FILLE',
  'demo.resultat.garcon': 'un GARÇON',

  'demo.puzzle.aria': 'Puzzle de la démonstration : {n} pièce(s) posée(s) sur 12',
  'demo.puzzle.pieceAGratter': 'La pièce à gratter',
  'demo.puzzle.compteur': '🧩 {n}/12 pièces — le vrai visuel du puzzle (14 × 21 cm)',

  'demo.pari.etiquette': 'Étape 1 — comme dans les règles : on forme les équipes',
  'demo.pari.titre': 'Vous, vous le sentez comment ?',
  'demo.pari.fille': '💗 Je parie sur une FILLE',
  'demo.pari.garcon': '💙 Je parie sur un GARÇON',
  'demo.pari.note':
    "Le jour J, chacun rejoint l'équipe de son intuition. Ici, le résultat est tiré au sort — chez vous, ce sera votre vrai secret.",

  'demo.questions.etiquette': 'Question {numero} sur 11 — tirée du vrai questionnaire',
  // Questions réelles du questionnaire fourni dans la boîte (numéros d'origine).
  'demo.question.5': 'Qui chantera les berceuses de manière désastreuse ?',
  'demo.question.7': 'Qui pleurera devant les films pour enfants ?',
  'demo.question.11':
    'Qui pourrait maladroitement réveiller le bébé en marchant sur un jouet bruyant ?',
  'demo.questions.maman': '🤱 Maman',
  'demo.questions.papa': '🧔 Papa',
  'demo.questions.gagne': '🧩 Pièce gagnée ! Elle rejoint le puzzle…',
  'demo.questions.note':
    "Dans le vrai jeu, ce sont les futurs parents qui tranchent — et il faut répondre plus vite que l'équipe adverse.",

  'demo.cascade.titre': '…et les huit autres se gagnent pareil.',
  'demo.cascade.texte':
    "Question après question, le puzzle se remplit — on vous les offre pour la démo. Il ne reste bientôt qu'une seule pièce.",

  'demo.subsidiaire.etiquette':
    'Il manque une pièce — la question subsidiaire décide qui la gratte',
  // La question de la DÉMO — volontairement DIFFÉRENTE de la vraie question
  // subsidiaire du jeu, pour ne pas éventer la surprise du jour J. Du coup,
  // ici, on peut donner la réponse.
  'demo.subsidiaire.question':
    'En moyenne, combien d’heures par jour dort un nouveau-né ?',
  'demo.subsidiaire.labelEstimation': 'Votre estimation du nombre d’heures',
  'demo.subsidiaire.placeholder': 'Votre estimation…',
  'demo.subsidiaire.valider': 'Je tente !',
  // Phrase de retour, coupée autour du <strong> (l'estimation saisie) et du
  // <sup> (l'exposant de « 12e »).
  'demo.subsidiaire.retourAvant': 'Votre estimation :',
  'demo.subsidiaire.retourApres':
    '. La réponse : environ 16 à 17 heures par jour ! Le jour J, la question sera différente — elle est imprimée dans les règles, réponse comprise 😉.',
  'demo.subsidiaire.retourPiece': 'Le joueur le plus proche gagne la 12',
  'demo.subsidiaire.retourExposant': 'e',
  'demo.subsidiaire.retourFin': "pièce. Aujourd'hui, ce privilège est à vous.",
  'demo.subsidiaire.cta': '🪙 Gratter la 12e pièce',

  'demo.grattage.etiquette': 'La 12e pièce est entre vos mains',
  // Les deux lignes peintes sur la couche argentée (canvas).
  'demo.grattage.grattez': '✨ GRATTEZ ✨',
  'demo.grattage.doigtOuSouris': 'doigt ou souris',
  'demo.grattage.aria': "La pièce est grattée : c'est {mot}.",
  'demo.grattage.revele': "C'est {mot} ! La pièce rejoint le puzzle…",
  'demo.grattage.revelerMaintenant': 'Révéler tout de suite',
  'demo.grattage.revelerSansGratter': 'Révéler sans gratter',

  'demo.final.titre': "C'est {mot} !",
  'demo.final.pariGagne': 'Et votre équipe avait vu juste. Respect.',
  'demo.final.pariPerdu': "L'autre équipe avait raison — ça arrive aux meilleurs.",
  // Phrase découpée autour du <strong> : avant / mot fort / après.
  'demo.final.texteAvant': "…dans cette démo, en tout cas. Le jour J, c'est",
  'demo.final.texteFort': 'votre',
  'demo.final.texteApres':
    "secret que vos proches découvriront — et le puzzle terminé (14 × 21 cm, le format d'un cadre) restera comme souvenir.",
  'demo.final.ctaBoutique': '🛒 Je veux vivre ça chez moi',
  'demo.final.rejouer': '↺ Rejouer',
};
